<template>
  <el-card>
    <template #header>
      <h3>FAQ</h3>
    </template>
    <el-collapse accordion>
      <el-collapse-item v-for="item in items" :key="item.title">
        <template #title>
          {{ item.title }}
        </template>
        <div v-html="item.description" />
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Faq',
  setup() {
    const items: any = [
      {
        title: 'What is the minimum deposit?',
        description:
          "<div class='faq-table'><div class='header-cell'>Payment method</div><div class='header-cell'>Minimal Payment</div><div class='header-cell'>Fee</div><div>Paxum</div><div>&#36; 5</div><div>&#36; 1</div><div>Paypal</div><div>50 &#8364;</div><div>3% + 0.35 &#8364;</div><div>Payoneer</div><div>&#36; 50</div><div>0%</div><div>Credit Card</div><div>&#36; 50</div><div>2-5%</div><div>Capitalist</div><div>&#36; 10</div><div>5%</div><div>Wire</div><div>&#36; 500</div><div>&#36; 25-50</div><div>USDT TRC-20</div><div>&#36; 50</div><div>&#36; 0.1-1</div><div>USDT ERC-20</div><div>&#36; 50</div><div>&#36; 0.1-1</div></div>"
      },
      {
        title: 'Do you support CPA or Revenue Share model?',
        description:
          "<p>We don't support CPA or Revenue Share.</p><p>We sell traffic on CPM and CPC only.</p><p><b>How to get CPA-like results: use Auto CPA.</b></p><p>You set a target cost per conversion, and the system automatically adjusts CPM bids and impression frequency (within your targeting) to keep performance close to that CPA.</p>"
      },
      {
        title: 'Can I sell traffic for you?',
        description:
          "<p>Yes; if you're a direct publisher with your own domains.</p><p>We onboard supply via our SSP AdSpyglass. Sign up at adspyglass.com</p>"
      },
      {
        title: 'Which websites will my ads be shown on?',
        description:
          "<p>On our network of 2,000+ direct publisher sites.</p><p>You can browse available sites in the Marketplace (by category, GEO, format, placement).</p><p>After you start buying, you'll get site-level reports and can manage domains as needed (allow/block).</p>"
      },
      {
        title: 'What is the recommended CPM rate?',
        description:
          '<ul><li>Start with the Recommended CPM shown in the creative setup, it reflects typical winning bids for this GEO and format.</li><li>Minimum CPM is the lowest possible bid for this GEO. You cannot bid below this value.</li><li>For faster delivery, choose Smart CPM and set the maximum CPM you are willing to pay. The system will optimize your bid automatically, and if your bid wins, you usually pay only slightly above the second-highest bid, often less than your maximum.</li></ul>'
      }
    ]
    return { items }
  }
})
</script>
<style lang="scss" scoped>
:deep(.el-collapse-item) {
  .el-collapse-item__content {
    line-height: 20px;
    color: rgb(var(--redesign-text-secondary));
    p,
    ul {
      margin: 0;
    }
    p:not(:last-child),
    li:not(:last-child) {
      margin: 0 0 8px;
    }
    ul {
      list-style-position: inside;
      padding: 0;
    }
  }
  .el-collapse-item__header {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
    padding: 16px 0;
    height: auto;
    &.focusing:focus:not(:hover) {
      color: inherit;
    }
  }
  .faq-table {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr;
    border: 1px solid #ddd;
    gap: 1px;
    background-color: #eee;
    border-radius: 4px;
    overflow: hidden;
    & > div {
      padding: 4px;
      display: flex;
      align-items: center;
      background-color: #fff;
    }
    .header-cell {
      background-color: rgb(var(--redesign-bg-muted));
      font-weight: bold;
      text-align: center;
      justify-content: center;
    }
  }
}
</style>
